<template>
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">{{ module }}</h4>

          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }"
                  >Dashboards</router-link
                >
              </li>
              <li class="breadcrumb-item active">{{ module }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card" v-for="(item, index) in data.data" :key="index" :style="(item.isread == 1 ? 'background: gainsboro;' : '')+' cursor:pointer;'">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <h4 class="card-title mb-0 text-primary" @click="rdr_srv_t(item.id, item.srv_t_uuid)">
                {{ item.label }}
              </h4>
              <button
                type="button"
                @click="deleteData(item.id)"
                class="btn btn-danger waves-effect waves-light btn-sm right-bar-toggle"
              >
                <i class="bx bx-trash mr-1"></i> Delete
              </button>
            </div>
            <div @click="rdr_srv_t(item.id, item.srv_t_uuid)">
              <p class="mb-0">
                {{ item.date_created }}
              </p>
              <h5 class="font-size-15 mt-4">Description :</h5>
              <p class="text-muted mb-0">
                {{ item.description }}
              </p>
              <p class="text-muted mb-0">
                {{ getDurationNotif(item.date_created) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12" v-if="data.total_page != 0">
        <paginate
          v-model="page"
          :pageCount="parseInt(data.total_page)"
          :initial-page="page"
          :click-handler="startPaginate"
          prevText="<i class='mdi mdi-chevron-left'></i>"
          nextText="<i class='mdi mdi-chevron-right'></i>"
          container-class="pagination pagination-rounded justify-content-center mt-4"
          pageClass="page-item"
          page-link-class="page-link"
          prev-class="page-item"
          prev-link-class="page-link"
          next-class="page-item"
          next-link-class="page-link"
        ></paginate>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      module: "Pemberitahuan",
      table_module: "notification",
      alias_table: "notification_admin",
      data: [],
      show: 10,
      page: 1,
      totalData: 0,
    };
  },
  mounted() {
    if (typeof this.$route.query.page !== 'undefined') 
    {
      this.page = this.$route.query.page
    }
    if (typeof this.$route.query.limit !== 'undefined') 
    {
      this.limit = this.$route.query.limit
    }
    if (typeof this.$route.query.orderBy !== 'undefined') 
    {
      this.orderBy = this.$route.query.orderBy
    }
    if (typeof this.$route.query.sort !== 'undefined') 
    {
      this.sort = this.$route.query.sort
    }
    this.fetchData();
  },
  methods: {
    fetchData(newValue={}) {
      this.isLoading = true;
      var params = {};

      params = {
        page: typeof newValue.page !== 'undefined' ? newValue.page : this.page,
        show: typeof newValue.show !== 'undefined' ? newValue.show : this.show,
      };

      this.axios
        .get("/" + this.table_module + "/admin", { params: params })
        .then((response) => {
          this.data = response.data.data;
          this.isLoading = false;
        });
    },
    startPaginate: function (pageNum) {
      var arm = {
        page: pageNum,
        show: parseInt(this.show),
      };
      this.fetchData(arm);
    },
    loading(arm) {
      if (arm == true) {
        this.fields = {};
        this.data = {};
      }
    },
    getDurationNotif(date) {
      var date_now = this.$moment(); //now
      var date_end = this.$moment(date);
      return date_end.from(date_now);
    },
    deleteData(id = 0) {
      var Swal = this.$swal;
      Swal.fire({
        title: "Yakin ingin hapus?",
        // text: "You will not be able to recover this imaginary file!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.axios
            .post("/" + this.table_module + "/admin_delete", { id: id })
            .then((response) => {
              if (response.data.status == 200) {
                this.fetchData();
                this.isLoading = false;
              }
            });
          // https://sweetalert2.github.io/#handling-dismissals
        } else if (result.dismiss) {
          // Swal.fire("Cancelled", "Hapus dibatalkan", "error");
        }
      });
    },
    rdr_srv_t(id, uuid){
      let param = {
        id : id
      }

      this.axios.post("notification/update_read_admin", param).then((response) => {
        this.$root.getNotificationUnread();
        if (response.data != undefined) {
          this.$router.push({
            name: "services_transaction_detail",
            params: { uuid: uuid }
          });
        }
      });      
    }
  },
};
</script>